import type { BlogPost } from '../types'

const post: BlogPost = {
  title: 'EQ – The Problem',
  slug: 'eq-the-problem',
  category: 'EQ',
  date: '2025-05-16',
  image: '',
  excerpt: 'When emotions hijack the ability to behave like a civilized human being.',
  body: `When emotions hijack the ability to behave like a civilized human being.

Do you know what your problem is?

Your problem is that all of your sensory input (sight, sound, smell, touch, taste) goes through your emotional brain before it hits your logical brain. And once the emotions get involved, they don't let go easily.

To restate that in biological terms, your five senses pass their information through your limbic system (the center of your emotional self), and then filter on to the prefrontal cortex (the logical part of your brain). That's why it is hard to think rationally when someone pulls in front of you in traffic. Or when your boss asks you to stay late and you had plans. Or when your significant other asks you to run an errand and you were very busy goofing off.

Emotional intelligence is the ability to pause and reframe a situation before acting out in an emotional way – out of fear, anger, shame….

The pause is one of the great suggestions in being able to behave like a sane human being. Pause between stimulus and response. Take a deep breath. Assess the situation rationally. Suggest to yourself that it's not that important to react emotionally, that there might be a way to move forward that does not add to the problem.

How well are you able to pause before reacting to a situation that requires a level head?

## EQ: Emotional Intelligence

Emotional intelligence, or emotional quotient (EQ), has four competencies. Two are about the self and two are social competencies. Two are about awareness and two are about management.

In short, EQ is the ability to know & manage one's own emotions, and to understand & respond well to the emotions of others. Specifically, they are:

1. **Self-Awareness** is knowing and understanding one's own emotions, motivations, strengths & weaknesses, values, and goals.
2. **Self-Regulation**, or self-management, is the ability to set aside an immediate emotional reaction in order to pursue a longer-range goal. It's the ability to pause, reflect, and redirect a reaction to a difficult stimulus.
3. **Social Awareness** is the ability to read other people, understand what's making them tick. Empathy is part of social awareness. It requires setting aside assumptions about what the other person thinks and really listening.
4. **Relationship Management** uses the previous three competencies to build relationships and is the ultimate usage of emotional intelligence. It is the ability to work with all kinds of people in all kinds of situations.

The next articles have some ideas on improvement in each area.`,
}

export default post
